import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const FileManagerIcon = createSvgIcon(
 <svg
  xmlns="http://www.w3.org/2000/svg"
  xmlSpace="preserve"
  width="560"
  height="560"
  version="1.1"
  viewBox="0 0 560 560"
  id="svg44">
  <g id="g85" transform="translate(-70,-70)">
   <path
    fill="#FEFEFE"
    d="M 350,71 C 504,71 629,196 629,350 629,504 504,629 350,629 196,629 71,504 71,350 71,196 196,71 350,71 Z"
    id="path9"
   />
   <path
    fill="#2BBCFF"
    d="m 231,211 h 208 l 38,24 v 246 c 0,5 -3,8 -8,8 H 231 c -5,0 -8,-3 -8,-8 V 219 c 0,-5 3,-8 8,-8 z"
    id="path13"
   />
   <path
    fill="#53C6FC"
    d="m 231,211 h 208 l 38,24 v 2 L 440,214 H 231 c -4,0 -7,3 -7,7 v 263 c -1,-1 -1,-2 -1,-3 V 219 c 0,-5 3,-8 8,-8 z"
    id="path15"
   />
   <polygon fill="#BDEAFF" points="305,212 418,212 418,310 305,310 " id="polygon17" />
   <path
    fill="#BDEAFF"
    d="m 255,363 h 189 c 3,0 5,2 5,4 V 483 H 250 V 367 c 0,-2 2,-4 5,-4 z"
    id="path19"
   />
   <polygon fill="#006498" points="250,470 449,470 449,483 250,483 " id="polygon21" />
   <path
    fill="#006498"
    d="m 380,226 h 10 c 3,0 6,2 6,5 v 40 c 0,3 -3,6 -6,6 h -10 c -3,0 -6,-3 -6,-6 v -40 c 0,-3 3,-5 6,-5 z"
    id="path23"
   />
   <path
    fill="#FEFEFE"
    d="m 254,226 c 10,0 17,7 17,17 0,9 -7,16 -17,16 -9,0 -17,-7 -17,-16 0,-10 8,-17 17,-17 z"
    id="path25"
   />
   <path
    fill="#006498"
    d="m 267,448 h 165 c 2,0 3,1 3,3 v 0 c 0,1 -1,3 -3,3 H 267 c -2,0 -3,-2 -3,-3 v 0 c 0,-2 1,-3 3,-3 z"
    id="path27"
   />
   <path
    fill="#006498"
    d="m 267,415 h 165 c 2,0 3,1 3,3 v 0 c 0,1 -1,2 -3,2 H 267 c -2,0 -3,-1 -3,-2 v 0 c 0,-2 1,-3 3,-3 z"
    id="path29"
   />
   <path
    fill="#006498"
    d="m 267,381 h 165 c 2,0 3,2 3,3 v 0 c 0,2 -1,3 -3,3 H 267 c -2,0 -3,-1 -3,-3 v 0 c 0,-1 1,-3 3,-3 z"
    id="path31"
   />
   <path
    fill="#FEFEFE"
    d="m 236,472 c 3,0 5,2 5,5 0,2 -2,4 -5,4 -3,0 -5,-2 -5,-4 0,-3 2,-5 5,-5 z"
    id="path33"
   />
   <path
    fill="#FEFEFE"
    d="m 463,472 c 3,0 5,2 5,5 0,2 -2,4 -5,4 -3,0 -5,-2 -5,-4 0,-3 2,-5 5,-5 z"
    id="path35"
   />
   <polygon fill="#006498" points="305,212 284,212 284,310 305,310 " id="polygon37" />
   <path
    fill="#0EA5EB"
    d="m 477,479 v 2 c 0,5 -3,8 -8,8 H 231 c -5,0 -8,-3 -8,-8 v -2 c 0,4 3,8 8,8 h 238 c 5,0 8,-4 8,-8 z"
    id="path39"
   />
  </g>
 </svg>,
 "FileManager"
);
